import Resource from '@/services/resources/common';

export default class GeometryGroupResource extends Resource {
  constructor(entrypoint = '/geometry_groups', alias = 'GeometryGroup') {
    super(entrypoint, alias);
  }
}
